import { i18n } from 'i18next'

export const formatDate = {
  ISO: (date: Date) => date.toISOString(),
  DDMMYYYY: (date: string | number | Date) => {
    const d = new Date(date)
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    return dd + '-' + mm + '-' + yyyy
  },
  DDMonthYYYY: (i18next: i18n, date: string | number | Date) => {
    const d = new Date(date)
    return d.toLocaleDateString(i18next.language, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  },
  month: (i18next: i18n, date: string | number | Date) => {
    const d = new Date(date)
    return d.toLocaleDateString(i18next.language, { month: 'long' })
  },
}
